// extracted by mini-css-extract-plugin
export default {"optional":"Relatives_optional__a6dRZ","pageTitle":"Relatives_pageTitle__vh-za","fieldGroupWrapper":"Relatives_fieldGroupWrapper__h-YXN","fieldRow":"Relatives_fieldRow__nu4ha"};